import _ from '../../core/utils'
import API from '../api'
import HINT from '../hint'
import MODAL from '../modal'
import SUBMIT from '../submit'
import API_PAGE_STATUS_CONFIG from './config'

class ApiPageStatusClass {
    constructor() {
        this.DOM = {
            forms: API_PAGE_STATUS_CONFIG.forms,
            edit: API_PAGE_STATUS_CONFIG.edit,
            editPublish: API_PAGE_STATUS_CONFIG.editPublish,
            editUnpublish: API_PAGE_STATUS_CONFIG.editUnpublish,
            pages: API_PAGE_STATUS_CONFIG.pages
        }

        this.endpoint = API_PAGE_STATUS_CONFIG.endpoint

        this.init()
    }

    init() {
        console.log( this )
        this.DOM.editPublish || this.DOM.editUnpublish ? this._listeners() : null
    }

    _listeners() {
        this.DOM.forms.forEach( ( form ) => { form.addEventListener( 'submit', this._submit.bind( this ) ) })
        this._editVisibility( this.DOM.edit.getAttribute( 'data-status' ) )
    }

    _editVisibility( status ) {
        console.log( status )
        if ( status === 'publish' ) {
            this.DOM.editPublish.style.display = 'block'
            this.DOM.editUnpublish.style.display = 'none'
        } else {
            this.DOM.editPublish.style.display = 'none'
            this.DOM.editUnpublish.style.display = 'block'
        }
    }

    _submit() {
        event.preventDefault()
        let form = event.target

        SUBMIT._startLoading( form )
        API.post( this.endpoint, 
            new FormData( form )
        )
        .then( ( response ) => {
            console.log( response )
            if ( response.data.success ) {
                HINT._show( response.data.message, HINT.status.success )
                this._editVisibility( response.data.status )
                this._pageStyles( response )
            } else {
                HINT._show( response.data.message, HINT.status.error )
            }
        })
        .catch( ( error ) => {
           
        })
        .then( () => {
            SUBMIT._endLoading( form )
            MODAL._close()
            HINT._hide()
        })
    }

    _pageStyles( response ) {
        let page = _.select( `.fl__page[data-id="${response.data.page_id}"]` )
        response.data.page_status === 'unpublish' ? _.addClass( page, 'fl__page--unpublished' ) : _.removeClass( page, 'fl__page--unpublished' )
    }
} 

const API_PAGE_STATUS = new ApiPageStatusClass()
export default API_PAGE_STATUS